import { render, staticRenderFns } from "./PreencherContrato.vue?vue&type=template&id=3963a08d&lang=pug"
import script from "./PreencherContrato.vue?vue&type=script&lang=js"
export * from "./PreencherContrato.vue?vue&type=script&lang=js"
import style0 from "./PreencherContrato.vue?vue&type=style&index=0&id=3963a08d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports